/** Whether to show the verified badge (platform-verified or email-verified). */
export function isProfileVerified(user?: {
  is_verified?: boolean;
  email_verified?: boolean;
  verified?: boolean;
} | null): boolean {
  if (!user) return false;
  if (user.verified === true) return true;
  if (user.is_verified === true) return true;
  if (user.email_verified === true) return true;
  // Explicitly marked unverified on both flags
  if (user.is_verified === false && user.email_verified === false) return false;
  // Default for signed-in users (legacy localStorage without flags)
  if (user.email_verified !== false) return true;
  return false;
}
